import Alpine from 'alpinejs';

import { pausedBannerAd } from './paused_banner_ad';

Alpine.data('pausedBannerAd', pausedBannerAd);
